import master from "../_ApiConn/apiMaster";
import ConnUrls from "../Connections/ConnectURL";


const getMaster = async () => {

    let dFromF = await master.getMaster();
    //קבצי מדיה שהוחלפו בשם זהה (ConnUrls.media)
    ConnUrls.setMediaVersions(dFromF.data && dFromF.data.mediaVersions);
    return (dFromF.data);
}

const getSiteMessages = async () => {
    
    let dFromF = await master.getSiteMessages();
    return (dFromF.data);
}

export default {
    getMaster,
    getSiteMessages
};